import React from 'react';

interface Props {
  width: number;
  height: number;
}

const SvgNotice = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1Inside-1_51736_9978" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.56 14C49.08 14 50.32 15.23 50.32 16.76H50.31V21.54C60.7 22.9 68.73 31.79 68.73 42.55V67.26H73.34C74.86 67.26 76.1 68.5 76.1 70.02C76.1 71.54 74.87 72.78 73.34 72.78H21.76C20.24 72.78 19 71.54 19 70.02C19 68.5 20.23 67.26 21.76 67.26H26.37V42.55C26.37 31.79 34.4 22.9 44.8 21.55V16.76C44.8 15.24 46.04 14 47.56 14ZM40.19 76.47C38.67 76.47 37.43 77.7 37.43 79.23C37.43 80.75 38.66 81.99 40.19 81.99H54.93C56.45 81.99 57.69 80.75 57.69 79.23C57.69 77.71 56.46 76.47 54.93 76.47H40.19Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.56 14C49.08 14 50.32 15.23 50.32 16.76H50.31V21.54C60.7 22.9 68.73 31.79 68.73 42.55V67.26H73.34C74.86 67.26 76.1 68.5 76.1 70.02C76.1 71.54 74.87 72.78 73.34 72.78H21.76C20.24 72.78 19 71.54 19 70.02C19 68.5 20.23 67.26 21.76 67.26H26.37V42.55C26.37 31.79 34.4 22.9 44.8 21.55V16.76C44.8 15.24 46.04 14 47.56 14ZM40.19 76.47C38.67 76.47 37.43 77.7 37.43 79.23C37.43 80.75 38.66 81.99 40.19 81.99H54.93C56.45 81.99 57.69 80.75 57.69 79.23C57.69 77.71 56.46 76.47 54.93 76.47H40.19Z"
      fill="#FFC773"
    />
    <path
      d="M50.32 16.76V18.76H52.32V16.76H50.32ZM50.31 16.76V14.76H48.31V16.76H50.31ZM50.31 21.54H48.31V23.2953L50.0504 23.5231L50.31 21.54ZM68.73 67.26H66.73V69.26H68.73V67.26ZM26.37 67.26V69.26H28.37V67.26H26.37ZM44.8 21.55L45.0575 23.5334L46.8 23.3072V21.55H44.8ZM52.32 16.76C52.32 14.1207 50.1798 12 47.56 12V16C47.9802 16 48.32 16.3393 48.32 16.76H52.32ZM50.31 18.76H50.32V14.76H50.31V18.76ZM52.31 21.54V16.76H48.31V21.54H52.31ZM70.73 42.55C70.73 30.7719 61.9415 21.0454 50.5696 19.5569L50.0504 23.5231C59.4585 24.7546 66.73 32.8081 66.73 42.55H70.73ZM70.73 67.26V42.55H66.73V67.26H70.73ZM73.34 65.26H68.73V69.26H73.34V65.26ZM78.1 70.02C78.1 67.3954 75.9646 65.26 73.34 65.26V69.26C73.7554 69.26 74.1 69.6046 74.1 70.02H78.1ZM73.34 74.78C75.9793 74.78 78.1 72.6398 78.1 70.02H74.1C74.1 70.4402 73.7607 70.78 73.34 70.78V74.78ZM21.76 74.78H73.34V70.78H21.76V74.78ZM17 70.02C17 72.6446 19.1354 74.78 21.76 74.78V70.78C21.3446 70.78 21 70.4354 21 70.02H17ZM21.76 65.26C19.1207 65.26 17 67.4002 17 70.02H21C21 69.5998 21.3393 69.26 21.76 69.26V65.26ZM26.37 65.26H21.76V69.26H26.37V65.26ZM24.37 42.55V67.26H28.37V42.55H24.37ZM44.5425 19.5666C33.1591 21.0443 24.37 30.7717 24.37 42.55H28.37C28.37 32.8083 35.6409 24.7557 45.0575 23.5334L44.5425 19.5666ZM42.8 16.76V21.55H46.8V16.76H42.8ZM47.56 12C44.9354 12 42.8 14.1354 42.8 16.76H46.8C46.8 16.3446 47.1446 16 47.56 16V12ZM39.43 79.23C39.43 78.8093 39.7698 78.47 40.19 78.47V74.47C37.5702 74.47 35.43 76.5907 35.43 79.23H39.43ZM40.19 79.99C39.7693 79.99 39.43 79.6501 39.43 79.23H35.43C35.43 81.8499 37.5507 83.99 40.19 83.99V79.99ZM54.93 79.99H40.19V83.99H54.93V79.99ZM55.69 79.23C55.69 79.6454 55.3454 79.99 54.93 79.99V83.99C57.5546 83.99 59.69 81.8546 59.69 79.23H55.69ZM54.93 78.47C55.3507 78.47 55.69 78.8098 55.69 79.23H59.69C59.69 76.6102 57.5693 74.47 54.93 74.47V78.47ZM40.19 78.47H54.93V74.47H40.19V78.47Z"
      fill="url(#paint0_linear_51736_9978)"
      fillOpacity="0.1"
      mask="url(#path-1Inside-1_51736_9978)"
    />
    <path
      d="M66 46C74.8366 46 82 38.8366 82 30C82 21.1634 74.8366 14 66 14C57.1634 14 50 21.1634 50 30C50 38.8366 57.1634 46 66 46Z"
      fill="#F88736"
    />
    <path
      d="M81 30C81 38.2843 74.2843 45 66 45C57.7157 45 51 38.2843 51 30C51 21.7157 57.7157 15 66 15C74.2843 15 81 21.7157 81 30Z"
      stroke="url(#paint1_linear_51736_9978)"
      strokeOpacity="0.1"
      strokeWidth="2"
    />
    <g filter="">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.99 20.8404C68.85 19.9904 68.12 19.3604 67.26 19.3604H64.58C63.72 19.4404 63.02 20.1404 62.98 21.0204L62.92 21.7804L62.9 21.9504L62.86 22.1204C62.76 22.5004 62.53 22.8204 62.21 23.0504L62.07 23.1404L62.04 23.1604L61.89 23.2404C61.44 23.4404 60.91 23.4404 60.44 23.2104L59.74 22.8504L59.59 22.7804C58.8 22.4704 57.89 22.7904 57.44 23.5204L56.16 25.7504L56.09 25.9004C55.74 26.6904 55.98 27.6004 56.68 28.0904L57.33 28.5304L57.47 28.6404C57.86 28.9704 58.09 29.4604 58.09 29.9704C58.09 30.5504 57.8 31.0904 57.34 31.4004L56.69 31.8404L56.56 31.9404C55.89 32.4904 55.71 33.4604 56.18 34.2104L57.43 36.4104L57.51 36.5504C57.99 37.2603 58.92 37.5104 59.72 37.1204L60.45 36.7604L60.6 36.7004L60.76 36.6504C61.13 36.5604 61.53 36.5904 61.9 36.7504L61.97 36.7804L62.06 36.8304L62.2 36.9204C62.62 37.2204 62.88 37.6804 62.92 38.1904L62.98 38.9804L63 39.1304C63.14 39.9804 63.87 40.6104 64.73 40.6104H67.41C68.27 40.5304 68.97 39.8304 69.01 38.9504L69.07 38.1904L69.09 38.0204L69.13 37.8504C69.23 37.4704 69.46 37.1504 69.78 36.9204L69.92 36.8204L69.95 36.8004L70.1 36.7204C70.55 36.5203 71.08 36.5204 71.55 36.7504L72.27 37.1004L72.41 37.1604C73.19 37.4604 74.1 37.1404 74.55 36.4104L75.83 34.1804L75.9 34.0404C76.25 33.2804 76.01 32.3704 75.33 31.8604L74.66 31.4004L74.52 31.2904C74.13 30.9604 73.9 30.4704 73.9 29.9604C73.9 29.3804 74.19 28.8404 74.65 28.5304L75.3 28.0904L75.43 27.9904C76.1 27.4404 76.28 26.4704 75.81 25.7204L74.56 23.5404L74.48 23.4004C74.01 22.7004 73.07 22.4504 72.27 22.8304L71.54 23.1904L71.39 23.2504L71.23 23.3004C70.86 23.3904 70.46 23.3604 70.09 23.2004L70.02 23.1704L69.93 23.1204L69.79 23.0304C69.37 22.7304 69.11 22.2704 69.07 21.7604L69.01 20.9704L68.99 20.8204V20.8404ZM66 25.3804C68.54 25.3804 70.59 27.4604 70.59 30.0004C70.59 32.5404 68.54 34.6204 66 34.6204C63.46 34.6204 61.41 32.5404 61.41 30.0004C61.41 27.4604 63.46 25.3804 66 25.3804ZM63.98 30.0004C63.98 28.8704 64.89 27.9504 66 27.9504C67.11 27.9504 68.02 28.8704 68.02 30.0004C68.02 31.1304 67.11 32.0504 66 32.0504C64.89 32.0504 63.98 31.1304 63.98 30.0004Z"
        fill="url(#paint2_linear_51736_9978)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M68.4966 20.9216L68.499 20.9214L68.5125 21.0224L68.5714 21.7982L68.5715 21.7994C68.6231 22.4575 68.9598 23.0518 69.4994 23.4372L69.5093 23.4443L69.5196 23.4509L69.6596 23.5409L69.6731 23.5496L69.6872 23.5574L69.7772 23.6074L69.7995 23.6199L69.823 23.6299L69.8915 23.6593C69.8918 23.6594 69.892 23.6595 69.8922 23.6596C70.3622 23.8626 70.8731 23.9017 71.3482 23.7862L71.3638 23.7824L71.3791 23.7776L71.5391 23.7276L71.5577 23.7218L71.5757 23.7146L71.7257 23.6546L71.7437 23.6474L71.7611 23.6388L72.4876 23.2806C73.0683 23.0064 73.7275 23.1917 74.0556 23.6655L74.1259 23.7884L74.1262 23.7891L75.3762 25.9691L75.3811 25.9776L75.3863 25.9859C75.7171 26.5137 75.5957 27.2028 75.1183 27.5993L75.0071 27.6848L74.3706 28.1157C74.3703 28.1159 74.3701 28.116 74.3699 28.1162C73.7704 28.5205 73.4 29.2167 73.4 29.9604C73.4 30.6194 73.6962 31.2483 74.197 31.672L74.2039 31.6779L74.2111 31.6835L74.3511 31.7935L74.3637 31.8034L74.377 31.8126L75.0377 32.2662C75.527 32.6387 75.6916 33.2892 75.4489 33.8245L75.3892 33.9439L74.1206 36.1541C73.7918 36.681 73.1398 36.9007 72.5975 36.6967L72.4779 36.6455L71.7698 36.3012C71.7695 36.3011 71.7692 36.301 71.7689 36.3008C71.1641 36.0052 70.4796 36.0045 69.8969 36.2634L69.8805 36.2707L69.8647 36.2792L69.7147 36.3592L69.6931 36.3707L69.6727 36.3843L69.6427 36.4043L69.6359 36.4088L69.6294 36.4135L69.4894 36.5135L69.4882 36.5143C69.0802 36.8076 68.778 37.2233 68.6465 37.7231L68.6463 37.7231L68.6433 37.7358L68.6033 37.9058L68.5968 37.9336L68.5934 37.9619L68.5734 38.1319L68.5723 38.1414L68.5715 38.151L68.5115 38.911L68.5109 38.9193L68.5105 38.9276C68.4826 39.5418 67.9961 40.0432 67.3849 40.1104H64.73C64.1216 40.1104 63.5983 39.6654 63.4945 39.056L63.4775 38.9283L63.4186 38.1525L63.4185 38.1513C63.3669 37.4933 63.0302 36.8989 62.4906 36.5135L62.4807 36.5064L62.4704 36.4998L62.3304 36.4098L62.3169 36.4011L62.3028 36.3933L62.2128 36.3433L62.1905 36.3309L62.1669 36.3208L62.0984 36.2914C62.0983 36.2914 62.0981 36.2913 62.098 36.2912C61.6279 36.0881 61.1169 36.0489 60.6418 36.1645L60.6262 36.1683L60.6109 36.1731L60.4509 36.2231L60.4323 36.2289L60.4143 36.2361L60.2643 36.2961L60.2463 36.3033L60.2288 36.3119L59.5009 36.6709C59.5006 36.6711 59.5003 36.6712 59.5 36.6714C58.9249 36.9512 58.2742 36.7729 57.934 36.2845L57.8647 36.1633L57.8641 36.1623L56.6147 33.9633L56.6094 33.954L56.6037 33.9448C56.2729 33.417 56.3943 32.7279 56.8716 32.3314L56.9828 32.2459L57.6194 31.815C57.6196 31.8149 57.6198 31.8147 57.62 31.8146C58.2195 31.4103 58.59 30.714 58.59 29.9704C58.59 29.3113 58.2937 28.6824 57.793 28.2587L57.786 28.2528L57.7789 28.2472L57.6389 28.1372L57.625 28.1262L57.6103 28.1163L56.9638 27.6787C56.47 27.331 56.2918 26.6842 56.5453 26.107L56.6042 25.9809L57.8694 23.7766C58.1963 23.2528 58.8432 23.0321 59.394 23.2407L59.5198 23.2994L60.2113 23.655L60.2113 23.6551L60.2202 23.6595C60.8252 23.9555 61.5101 23.9563 62.0931 23.6973L62.1095 23.69L62.1253 23.6815L62.2753 23.6015L62.2969 23.59L62.3173 23.5764L62.3439 23.5587L62.4804 23.4709L62.4913 23.4639L62.5018 23.4564C62.9098 23.1631 63.212 22.7474 63.3435 22.2476L63.3437 22.2476L63.3467 22.2349L63.3867 22.0649L63.3932 22.0371L63.3966 22.0088L63.4166 21.8388L63.4177 21.8293L63.4184 21.8197L63.4784 21.0597L63.4791 21.0514L63.4795 21.0431C63.5074 20.4289 63.9939 19.9275 64.6051 19.8604H67.26C67.8707 19.8604 68.3957 20.3087 68.4966 20.9216ZM71.09 30.0004C71.09 27.1885 68.8204 24.8804 66 24.8804C63.1796 24.8804 60.91 27.1885 60.91 30.0004C60.91 32.8122 63.1796 35.1204 66 35.1204C68.8204 35.1204 71.09 32.8122 71.09 30.0004ZM64.48 30.0004C64.48 29.1401 65.1725 28.4504 66 28.4504C66.8275 28.4504 67.52 29.1401 67.52 30.0004C67.52 30.8606 66.8275 31.5504 66 31.5504C65.1725 31.5504 64.48 30.8606 64.48 30.0004Z"
        stroke="url(#paint3_linear_51736_9978)"
        strokeOpacity="0.1"
        strokeLinecap="round"
        shapeRendering="geometricPrecision"
      />
    </g>
    <defs>
      <filter
        id="filter0_di_51736_9978"
        x="55.917"
        y="19.3604"
        width="20.1558"
        height="22.25"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_9978"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_9978"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_9978"
        />
      </filter>
      <linearGradient
        id="paint0_linear_51736_9978"
        x1="47.55"
        y1="14"
        x2="47.55"
        y2="81.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_51736_9978"
        x1="66"
        y1="14"
        x2="66"
        y2="46"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_51736_9978"
        x1="65.995"
        y1="19.3604"
        x2="65.995"
        y2="40.6104"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_51736_9978"
        x1="65.995"
        y1="19.3604"
        x2="65.995"
        y2="40.6104"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgNotice;
